import React from "react";
import Home from "./pages/Home";
import Roles from "./pages/Roles";
import Users from "./pages/Users";
import Requirements from "./pages/Requirements";
import Vendor from "./pages/Vendor";
import ComplianceDocument from "./pages/complianceDocument";
import JobCard from "./pages/requirementsDescription";
import Invoice from "./pages/Invoice";
import TimeSheet from "./pages/TimeSheet";
import Consultant from "./pages/Consultant";
import TaskForm from "./pages/addTimesheet";
import EditTaskForm from "./pages/editTimesheet";
import InvoiceForm from "./pages/autoGenerateInvoice";
import CandidateForm from "./pages/candidateOnBoard";
import compnayProfilePage from "./pages/compnayProfilePage";
import CompnayProfilePage from "./pages/compnayProfilePage";
import CandidateDetails from "./pages/candidateDetails";
import TemplateSelection from "./pages/TemplateSelection";
import Setting from "./pages/Setting";
import Client from "./pages/client";
import Candidate from "./pages/candidate";
import CandidateRequirement from "./pages/candidatRequirementWise";
import JobPosting from "./pages/jobPosting";
import RelevantJobs from "./pages/relevantJobs";
import Leads from "./pages/leads";
import JobCompany from "./pages/jobCompany";
import JobCompanyView from "./pages/jbCompanyView";
import OutreachTablePage from "./pages/OutreachTable";
import SpocOutreachSummary from "./pages/OutreachSummary";

const dashboard = [
  <svg
    width="20"
    height="21"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0032 5.84582L11.3744 11.3658L11.5587 14.1402C11.5607 14.4255 11.6053 14.709 11.6916 14.9814C11.9141 15.5102 12.4496 15.8462 13.0321 15.8227L21.9084 15.242C22.2928 15.2358 22.664 15.3795 22.9403 15.6418C23.1705 15.8603 23.3192 16.1462 23.3661 16.4536L23.3819 16.6403C23.0145 21.7266 19.2789 25.969 14.2032 27.064C9.1274 28.1591 3.92248 25.8458 1.41428 21.3799C0.691184 20.0824 0.239531 18.6564 0.0858377 17.1854C0.0216377 16.7499 -0.00662902 16.31 0.00130431 15.87C-0.00662902 10.417 3.87662 5.70265 9.31244 4.56613C9.96668 4.46425 10.608 4.8106 10.8704 5.40741C10.9383 5.54562 10.9831 5.69365 11.0032 5.84582Z"
      fill="#13487D"
    />
    <path
      d="M26.6663 11.083L26.657 11.1265L26.6301 11.1897L26.6338 11.3632C26.6199 11.5929 26.5311 11.814 26.3783 11.9926C26.219 12.1786 26.0014 12.3053 25.7618 12.3545L25.6157 12.3745L15.3746 13.0381C15.0339 13.0717 14.6947 12.9618 14.4415 12.736C14.2303 12.5476 14.0954 12.2934 14.0573 12.0196L13.3699 1.79337C13.3579 1.7588 13.3579 1.72132 13.3699 1.68673C13.3793 1.40485 13.5034 1.13841 13.7145 0.946932C13.9254 0.755452 14.2059 0.654892 14.493 0.667718C20.5729 0.822398 25.6827 5.19435 26.6663 11.083Z"
      fill="#13487D"
    />
  </svg>,
];

const roles = [
  <svg
    width="19"
    height="22"
    viewBox="0 0 26 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8864 0.333374C8.61619 0.333374 5.15454 3.79503 5.15454 8.06519C5.15454 12.3353 8.61619 15.797 12.8864 15.797C17.1565 15.797 20.6182 12.3353 20.6182 8.06519C20.6182 3.79503 17.1565 0.333374 12.8864 0.333374Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2379 17.0856L11.5196 17.9309L12.8864 21.3477L14.2531 17.9309L14.5348 17.0856H11.2379ZM8.5212 17.0856L9.08659 18.7818C9.09457 18.8057 9.10325 18.8294 9.11262 18.8529L10.4934 22.3049C11.3575 24.465 14.4152 24.465 15.2794 22.3049L16.6601 18.8529C16.6695 18.8294 16.6782 18.8057 16.6862 18.7818L17.2515 17.0856H19.3295C22.888 17.0856 25.7727 19.9704 25.7727 23.5288V24.8175C25.7727 26.9526 24.042 28.6834 21.9068 28.6834H3.86591C1.73083 28.6834 0 26.9526 0 24.8175V23.5288C0 19.9704 2.88472 17.0856 6.44318 17.0856H8.5212Z"
      fill="white"
    />
  </svg>,
];

const users = [
  <svg
    width="19"
    height="18"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 13.6833C13.3398 13.6833 16.25 10.7732 16.25 7.18335C16.25 3.5935 13.3398 0.68335 9.75 0.68335C6.16015 0.68335 3.25 3.5935 3.25 7.18335C3.25 10.7732 6.16015 13.6833 9.75 13.6833Z"
      fill="#13487D"
    />
    <path
      d="M6.96428 14.7667C3.11802 14.7667 0 17.8847 0 21.731C0 23.2695 1.24721 24.5167 2.78572 24.5167H16.7143C18.2528 24.5167 19.5 23.2695 19.5 21.731C19.5 17.8847 16.382 14.7667 12.5357 14.7667H6.96428Z"
      fill="#13487D"
    />
    <path
      d="M17.1572 11.6852C16.9623 12.0052 17.1074 12.4353 17.4758 12.5034C17.7928 12.5621 18.1205 12.6 18.4167 12.6C21.4082 12.6 23.8333 10.1749 23.8333 7.18336C23.8333 4.19182 21.4082 1.76669 18.4167 1.76669C18.1205 1.76669 17.7928 1.80466 17.4758 1.86333C17.1074 1.9315 16.9623 2.36157 17.1572 2.68154C17.9564 3.99361 18.4167 5.53473 18.4167 7.18336C18.4167 8.83199 17.9564 10.3731 17.1572 11.6852Z"
      fill="#13487D"
    />
    <path
      d="M21.2951 23.6164C21.1293 24.0188 21.3991 24.5167 21.8341 24.5167H23.2143C24.7529 24.5167 26 23.2695 26 21.731C26 17.8847 22.8821 14.7667 19.0358 14.7667C18.833 14.7718 18.74 15.0285 18.8857 15.1696C20.6006 16.8296 21.6667 19.1558 21.6667 21.731C21.6667 22.3986 21.5346 23.0353 21.2951 23.6164Z"
      fill="#13487D"
    />
  </svg>,
];

const requirments = [
  <svg
    width="19"
    height="22"
    viewBox="0 0 26 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4.45863C0 2.3736 1.6531 0.68335 3.69231 0.68335H22.3077C24.3469 0.68335 26 2.3736 26 4.45863V24.9081C26 26.9931 24.3469 28.6833 22.3077 28.6833H3.69231C1.6531 28.6833 0 26.9931 0 24.9081V4.45863ZM4.07692 10.2789C4.07692 9.80104 4.45576 9.41369 4.92308 9.41369H13.2308C13.6981 9.41369 14.0769 9.80104 14.0769 10.2789C14.0769 10.7567 13.6981 11.144 13.2308 11.144H4.92308C4.45576 11.144 4.07692 10.7567 4.07692 10.2789ZM16.7692 9.41369C16.3019 9.41369 15.9231 9.80104 15.9231 10.2789C15.9231 10.7567 16.3019 11.144 16.7692 11.144H18.6154C19.0827 11.144 19.4615 10.7567 19.4615 10.2789C19.4615 9.80103 19.0827 9.41369 18.6154 9.41369H16.7692ZM4.07692 16.2564C4.07692 15.7786 4.45576 15.3912 4.92308 15.3912H20.7692C21.2365 15.3912 21.6154 15.7786 21.6154 16.2564C21.6154 16.7342 21.2365 17.1216 20.7692 17.1216H4.92308C4.45576 17.1216 4.07692 16.7342 4.07692 16.2564ZM4.92308 21.3687C4.45576 21.3687 4.07692 21.7561 4.07692 22.2339C4.07692 22.7117 4.45576 23.0991 4.92308 23.0991H18.1538C18.6212 23.0991 19 22.7117 19 22.2339C19 21.7561 18.6212 21.3687 18.1538 21.3687H4.92308Z"
      fill="#13487D"
    />
  </svg>,
];

const consultant = [
  <svg
    width="23"
    height="24"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 22.6833C25.2091 22.6833 27 20.8925 27 18.6833C27 16.4742 25.2091 14.6833 23 14.6833C20.7909 14.6833 19 16.4742 19 18.6833C19 20.8925 20.7909 22.6833 23 22.6833Z"
      fill="#13487D"
    />
    <path
      d="M26.5 24.6833H19.5C17.5693 24.6833 16 26.1629 16 27.9833V29.7833C16 30.2801 16.4276 30.6833 16.9545 30.6833H29.0455C29.5724 30.6833 30 30.2801 30 29.7833V27.9833C30 26.1629 28.4307 24.6833 26.5 24.6833Z"
      fill="#13487D"
    />
    <path
      d="M5.5 24.6833C6.88071 24.6833 8 23.5641 8 22.1833C8 20.8026 6.88071 19.6833 5.5 19.6833C4.11929 19.6833 3 20.8026 3 22.1833C3 23.5641 4.11929 24.6833 5.5 24.6833Z"
      fill="#13487D"
    />
    <path
      d="M6.5625 25.6833H3.4375C1.54125 25.6833 0 27.2246 0 29.1208V29.7458C0 30.2633 0.42 30.6833 0.9375 30.6833H9.0625C9.58 30.6833 10 30.2633 10 29.7458V29.1208C10 27.2246 8.45875 25.6833 6.5625 25.6833Z"
      fill="#13487D"
    />
    <path
      d="M15.5167 0.68335H3.48333C1.5618 0.68335 0 2.2246 0 4.12085V13.4958C0 15.3921 1.5618 16.9333 3.48333 16.9333H9.7622L13.6053 20.4346C13.7851 20.5983 14.0157 20.6833 14.25 20.6833C14.3792 20.6833 14.5084 20.6571 14.6313 20.6046C14.9758 20.4546 15.2 20.1183 15.2 19.7458V16.9333H15.5167C17.4382 16.9333 19 15.3921 19 13.4958V4.12085C19 2.2246 17.4382 0.68335 15.5167 0.68335ZM12.9833 11.3083H6.01667C5.49227 11.3083 5.06667 10.8883 5.06667 10.3708C5.06667 9.85335 5.49227 9.43335 6.01667 9.43335H12.9833C13.5077 9.43335 13.9333 9.85335 13.9333 10.3708C13.9333 10.8883 13.5077 11.3083 12.9833 11.3083ZM12.9833 6.93335H6.01667C5.49227 6.93335 5.06667 6.51335 5.06667 5.99585C5.06667 5.47835 5.49227 5.05835 6.01667 5.05835H12.9833C13.5077 5.05835 13.9333 5.47835 13.9333 5.99585C13.9333 6.51335 13.5077 6.93335 12.9833 6.93335Z"
      fill="#13487D"
    />
  </svg>,
];

const vendor = [
  <svg
    width="19"
    height="20"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9163 26.6833H16.2498C15.9128 26.6833 15.5954 26.5263 15.3907 26.2598C15.1859 25.9922 15.1155 25.6455 15.2033 25.3194C15.8435 22.9328 18.0556 21.2667 20.583 21.2667C23.1104 21.2667 25.3225 22.9328 25.9628 25.3194C26.0505 25.6455 25.9812 25.9922 25.7754 26.2598C25.5717 26.5273 25.2532 26.6833 24.9163 26.6833ZM20.583 20.1833C19.0891 20.1833 17.8747 18.9689 17.8747 17.475C17.8747 15.9811 19.0891 14.7667 20.583 14.7667C22.0769 14.7667 23.2913 15.9811 23.2913 17.475C23.2913 18.9689 22.0769 20.1833 20.583 20.1833ZM25.9584 9.0521L24.6888 4.61152C24.028 2.2986 21.8852 0.68335 19.4802 0.68335H18.4164V5.01668C18.4164 5.61468 17.9321 6.10002 17.3331 6.10002C16.734 6.10002 16.2498 5.61468 16.2498 5.01668V0.68335H9.74985V5.01668C9.74985 5.61468 9.26453 6.10002 8.66654 6.10002C8.06854 6.10002 7.58322 5.61468 7.58322 5.01668V0.68335H6.51832C4.11335 0.68335 1.97164 2.2986 1.30973 4.61152L0.0422494 9.0521C0.0151664 9.14852 0 9.24927 0 9.35002C0 11.7399 1.94347 13.6833 4.33327 13.6833H5.41658C6.71657 13.6833 7.87138 13.0962 8.66654 12.1862C9.46169 13.0962 10.6165 13.6833 11.9165 13.6833H14.0831C15.3842 13.6833 16.5379 13.0962 17.3331 12.1862C18.1282 13.0962 19.282 13.6833 20.583 13.6833H21.6663C24.0561 13.6833 25.9996 11.7399 25.9996 9.35002C25.9996 9.24927 25.9855 9.14852 25.9584 9.0521ZM13.1114 24.755C13.6325 22.8115 14.9086 21.2277 16.5693 20.231C16.0288 19.4456 15.7081 18.4977 15.7081 17.4739C15.7081 16.7676 15.8663 16.1003 16.1371 15.4947C15.4795 15.7189 14.7894 15.8489 14.0831 15.8489H11.9165C10.766 15.8489 9.64694 15.5369 8.66654 14.9617C7.68613 15.5369 6.56707 15.8489 5.41658 15.8489H4.33327C3.1492 15.8489 2.04097 15.525 1.08332 14.9693V22.3489C1.08332 24.7388 3.02679 26.6823 5.41658 26.6823H13.2078C12.9901 26.0669 12.9391 25.3953 13.1114 24.755Z"
      fill="#13487D"
    />
  </svg>,
];

const Compliance_Documents = [
  <svg
    width="19"
    height="22"
    viewBox="0 0 24 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.382 0.68335H4.61804C2.07577 0.68335 0 2.58423 0 4.9166V24.4385C0 26.7709 2.07577 28.6717 4.61804 28.6717H19.382C21.9242 28.6717 24 26.7709 24 24.4385V4.9166C24 2.58423 21.9242 0.68335 19.382 0.68335ZM8.53391 5.84918H14.3899C15.0339 5.84918 15.5561 6.37077 15.5561 7.01536C15.5561 7.65995 15.0339 8.18154 14.3899 8.18154H8.53391C7.88989 8.18154 7.36772 7.65995 7.36772 7.01536C7.36772 6.37077 7.88989 5.84918 8.53391 5.84918ZM4.93514 12.2529C4.93514 11.6083 5.4573 11.0868 6.10132 11.0868H16.8225C17.4665 11.0868 17.9886 11.6083 17.9886 12.2529C17.9886 12.8975 17.4665 13.4191 16.8225 13.4191H6.10132C5.4573 13.4191 4.93514 12.8975 4.93514 12.2529ZM15.6035 23.5056C13.7027 23.5056 12.1399 21.9545 12.1399 20.042C12.1399 18.1411 13.7027 16.5901 15.6035 16.5901C17.516 16.5901 19.0671 18.1411 19.0671 20.042C19.0671 21.9545 17.516 23.5056 15.6035 23.5056Z"
      fill="#13487D"
    />
  </svg>,
];

const invoices = [
  <svg
    width="20"
    height="21"
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.25805 0.671753C1.45798 0.671753 0 2.10375 0 3.87175V22.2718C0 22.5678 0.162903 22.8318 0.423547 22.9758L3.41281 24.5758C3.53499 24.6398 3.66531 24.6718 3.80378 24.6718C3.94224 24.6718 4.07257 24.6398 4.19474 24.5758L6.78489 23.1838L9.38319 24.5758C9.62755 24.7038 9.92077 24.7038 10.1651 24.5758L12.7634 23.1838L15.3617 24.5758C15.6061 24.7038 15.8993 24.7038 16.1437 24.5758L17.9274 23.3678V4.67175C17.9274 2.46375 19.7519 0.671753 22 0.671753H3.25805ZM6.24732 8.27175H4.75676C3.48612 8.27175 2.45168 7.25575 2.45168 6.00775C2.45168 4.75975 3.45354 3.78375 4.6916 3.75175V3.07975C4.6916 2.63975 5.05813 2.27975 5.50611 2.27975C5.95409 2.27975 6.32062 2.63975 6.32062 3.07975V3.74375H7.74602C8.194 3.74375 8.56053 4.10375 8.56053 4.54375C8.56053 4.98375 8.194 5.34375 7.74602 5.34375H4.75676C4.38208 5.34375 4.08071 5.63975 4.08071 6.00775C4.08071 6.37575 4.38208 6.67175 4.75676 6.67175H6.24732C7.51796 6.67175 8.55239 7.68775 8.55239 8.93575C8.55239 10.1838 7.55054 11.1598 6.31248 11.1918V11.8638C6.31248 12.3038 5.94595 12.6638 5.49796 12.6638C5.04998 12.6638 4.68345 12.3038 4.68345 11.8638V11.1998H3.25805C2.81007 11.1998 2.44354 10.8398 2.44354 10.3998C2.44354 9.95975 2.81007 9.59975 3.25805 9.59975H6.24732C6.62199 9.59975 6.92336 9.30375 6.92336 8.93575C6.92336 8.56775 6.62199 8.27175 6.24732 8.27175ZM2.44354 13.4718H2.8508C3.29878 13.4718 3.66531 13.8318 3.66531 14.2718C3.66531 14.7118 3.29878 15.0718 2.8508 15.0718H2.44354C1.99556 15.0718 1.62903 14.7118 1.62903 14.2718C1.62903 13.8318 1.99556 13.4718 2.44354 13.4718ZM15.4757 18.2718H2.44354C1.99556 18.2718 1.62903 17.9118 1.62903 17.4718C1.62903 17.0318 1.99556 16.6718 2.44354 16.6718H15.4757C15.9237 16.6718 16.2903 17.0318 16.2903 17.4718C16.2903 17.9118 15.9237 18.2718 15.4757 18.2718ZM15.4757 15.0718H5.70159C5.25361 15.0718 4.88708 14.7118 4.88708 14.2718C4.88708 13.8318 5.25361 13.4718 5.70159 13.4718H15.4757C15.9237 13.4718 16.2903 13.8318 16.2903 14.2718C16.2903 14.7118 15.9237 15.0718 15.4757 15.0718ZM15.4757 11.4718H11.4032C10.9552 11.4718 10.5887 11.1118 10.5887 10.6718C10.5887 10.2318 10.9552 9.87175 11.4032 9.87175H15.4757C15.9237 9.87175 16.2903 10.2318 16.2903 10.6718C16.2903 11.1118 15.9237 11.4718 15.4757 11.4718ZM15.4757 8.27175H11.4032C10.9552 8.27175 10.5887 7.91175 10.5887 7.47175C10.5887 7.03175 10.9552 6.67175 11.4032 6.67175H15.4757C15.9237 6.67175 16.2903 7.03175 16.2903 7.47175C16.2903 7.91175 15.9237 8.27175 15.4757 8.27175ZM15.4757 5.07175H11.4032C10.9552 5.07175 10.5887 4.71175 10.5887 4.27175C10.5887 3.83175 10.9552 3.47175 11.4032 3.47175H15.4757C15.9237 3.47175 16.2903 3.83175 16.2903 4.27175C16.2903 4.71175 15.9237 5.07175 15.4757 5.07175Z"
      fill="#13487D"
    />
  </svg>,
];

const TimeSheets = [
  <svg
    width="20"
    height="26"
    viewBox="0 0 24 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2763 5.67175H23.0343C23.3907 5.67175 23.5691 5.2409 23.3172 4.98891L19.6828 1.35459C19.4309 1.10261 19 1.28108 19 1.63744V5.39559C19 5.5479 19.1238 5.67175 19.2763 5.67175Z"
      fill="#13487D"
    />
    <path
      d="M18.9126 7.54275C17.7951 7.54275 16.886 6.66438 16.886 5.58533V0.671753H3.26524C1.46524 0.671753 0 2.08666 0 3.82549V26.518C0 28.2568 1.46524 29.6718 3.26524 29.6718H20.7343C22.5348 29.6718 24 28.2568 24 26.518V7.54275H18.9126ZM14.7729 26.1974H9.2266C8.74184 26.1974 8.34855 25.8173 8.34855 25.3478C8.34855 24.8788 8.74184 24.4982 9.2266 24.4982H14.7729C15.2582 24.4982 15.651 24.8788 15.651 25.3478C15.651 25.8173 15.2582 26.1974 14.7729 26.1974ZM17.1144 23.3654H6.88514C6.40038 23.3654 6.00709 22.9853 6.00709 22.5158C6.00709 22.0467 6.40038 21.6662 6.88514 21.6662H17.1144C17.5996 21.6662 17.9925 22.0467 17.9925 22.5158C17.9925 22.9853 17.5996 23.3654 17.1144 23.3654ZM11.9403 20.0112C8.11075 20.0112 4.99482 16.9962 4.99482 13.2902C4.99482 9.58469 8.11075 6.56968 11.9403 6.56968C15.7704 6.56968 18.8863 9.58469 18.8863 13.2902C18.8863 16.9962 15.7704 20.0112 11.9403 20.0112ZM11.9403 8.2689C9.07912 8.2689 6.75091 10.5215 6.75091 13.2902C6.75091 16.0594 9.07912 18.312 11.9403 18.312C14.8022 18.312 17.1302 16.0594 17.1302 13.2902C17.1302 10.5215 14.8022 8.2689 11.9403 8.2689ZM13.773 14.6496H12.4221C11.6721 14.6496 11.0623 14.06 11.0623 13.3343V10.8637C11.0623 10.3947 11.4556 10.0141 11.9403 10.0141C12.4255 10.0141 12.8184 10.3947 12.8184 10.8637V12.9504H13.773C14.2578 12.9504 14.6511 13.3309 14.6511 13.8C14.6511 14.2695 14.2578 14.6496 13.773 14.6496Z"
      fill="#13487D"
    />
  </svg>,
];

const setting = [
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    fill="none"
  >
    <path
      fill="currentColor"
      d="M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160a80 80 0 1 0 0 160"
    ></path>
  </svg>,

  // <svg
  //   width="25"
  //   height="25"
  //   viewBox="0 0 17 17"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <path
  //     fill="#13487D"
  //     clip-rule="evenodd"
  //     d="M7.75001 16.2306C7.35725 16.2306 7.0222 15.9423 6.95822 15.5492C6.89935 15.2311 6.67363 14.9713 6.37001 14.872C6.12261 14.7859 5.88072 14.6843 5.64572 14.5677C5.3661 14.4227 5.03065 14.4443 4.77144 14.6242C4.45776 14.8531 4.02684 14.8176 3.75358 14.5406L2.69072 13.4624C2.40468 13.1722 2.36752 12.7147 2.60287 12.381C2.78437 12.112 2.81052 11.7651 2.67144 11.4713C2.5798 11.2671 2.49897 11.0581 2.4293 10.8453C2.32951 10.5098 2.05406 10.2584 1.71465 10.1931C1.30535 10.1268 1.00319 9.77019 1.00001 9.34974V8.00095C0.997831 7.5163 1.34291 7.10177 1.8143 7.02278C2.1719 6.95378 2.47051 6.70532 2.60715 6.36306C2.64787 6.26669 2.69072 6.17105 2.73572 6.07613C2.91746 5.72121 2.89236 5.29372 2.67037 4.96319C2.39275 4.57179 2.43537 4.03403 2.77108 3.69266L3.55215 2.90034C3.93738 2.50943 4.54495 2.45883 4.98787 2.78079L5.01251 2.79818C5.34325 3.02399 5.7641 3.06488 6.13108 2.90686C6.52368 2.76352 6.81302 2.4213 6.89287 2.00586L6.90358 1.96891C6.99181 1.41893 7.45999 1.01487 8.0093 1.01465H8.95215C9.51628 1.01439 9.99774 1.42827 10.09 1.99282L10.1072 2.0689C10.1829 2.46688 10.4572 2.79624 10.8314 2.93838C11.1921 3.0954 11.6068 3.05439 11.9307 2.8297L11.9843 2.79057C12.4387 2.45836 13.0636 2.50946 13.4597 2.91121L14.1786 3.64158C14.5389 4.00911 14.5842 4.58706 14.2857 5.00775C14.0519 5.35937 14.0221 5.81121 14.2075 6.19134L14.2536 6.30002C14.4038 6.67114 14.7286 6.94016 15.1172 7.01517C15.6249 7.09913 15.9983 7.54323 16 8.06508V9.27475C15.9999 9.73489 15.6718 10.1275 15.2243 10.2029C14.8563 10.2745 14.5565 10.5448 14.4432 10.9072C14.3932 11.0521 14.3375 11.197 14.2761 11.3419C14.1331 11.6603 14.1648 12.0314 14.3597 12.3201C14.6168 12.6829 14.5768 13.1812 14.2654 13.4972L13.2679 14.5101C12.9826 14.7994 12.5328 14.8367 12.205 14.5982C11.9314 14.4086 11.577 14.3877 11.2836 14.5438C11.0745 14.6489 10.8599 14.7421 10.6407 14.8231C10.3343 14.9304 10.1084 15.1965 10.0493 15.5198C9.98683 15.9266 9.64298 16.2275 9.23715 16.2306H7.75001Z"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <circle
  //     cx="8.45"
  //     cy="8.8"
  //     r="2.5"
  //     fill="transperant"
  //     stroke="black"
  //     stroke-width="0.5"
  //   />
  // </svg>,
];

export const CompanyRoutesConfig = [
  {
    path: "/company/dashboard",
    name: "Dashboard",
    component: Home,
    permission: "view_dashboard",
    icon: dashboard,
  },
  {
    path: "/company/requirements",
    name: "Requirements",
    component: Requirements,
    permission: "view_requirements",
    icon: requirments,
  },
  {
    path: "/company/Client",
    name: "Client",
    component: Client,
    permission: "view_client",
    icon: vendor,
  },
  {
    path: "/company/consultants",
    name: "Candidate",
    component: Candidate,
    permission: "view_candidates",
    icon: consultant,
  },
  // {
  //   path: "/company/Compliance_Documents",
  //   name: "Compliance Documents",
  //   component: ComplianceDocument,
  //   permission: "view_compliance_documents",
  //   icon: Compliance_Documents,
  // },
  // {
  //   path: "/company/invoices",
  //   name: "Invoices",
  //   component: Invoice,
  //   permission: "view_invoices",
  //   icon: invoices,
  // },
  // {
  //   path: "/company/TimeSheet",
  //   name: "Timesheet",
  //   component: TimeSheet,
  //   permission: "view_timesheet",
  //   icon: TimeSheets,
  // },
  // {
  //   path: "/company/roles",
  //   name: "Roles",
  //   component: Roles,
  //   permission: "view_roles",
  //   icon: roles,
  // },
  // {
  //   path: "/company/users",
  //   name: "Users",
  //   component: Users,
  //   permission: "view_users",
  //   icon: users,
  // },
  {
    path: "/company/requirement_description",
    name: "Requirement Description",
    component: JobCard,
    permission: "view_requirements",
    icon: "",
  },
  {
    path: "/company/add-TimeSheet",
    name: "Add-Timesheet",
    component: TaskForm,
    permission: "add_timesheet",
    icon: "",
  },
  {
    path: "/company/edit-TimeSheet",
    name: "Edit-Timesheet",
    component: EditTaskForm,
    permission: "edit_timesheet",
    icon: "",
  },
  {
    path: "/company/Candidate/create",
    name: "Candidate-Onboard",
    component: CandidateForm,
    permission: "",
    icon: "",
  },
  {
    path: "/company/profile",
    name: "Company-profile",
    component: CompnayProfilePage,
    permission: "company_profile",
    icon: setting,
  },
  {
    path: "/company/candidate-details",
    name: "Candidate-details",
    component: CandidateDetails,
    permission: "view_candidates",
    icon: "",
  },
  {
    path: "/company/candidate-requirement",
    name: "Candidate-Requirement",
    component: CandidateRequirement,
    permission: "view_requirements",
    icon: consultant,
  },
  {
    path: "/company/jobposting",
    name: "Job Posting",
    component: JobPosting,
    permission: "view_requirements",
    icon: consultant,
  },
  // {
  //   path: "/company/relevantJobs",
  //   name: "Relevant Jobs",
  //   component: RelevantJobs,
  //   permission: "view_requirements",
  //   icon: consultant,
  // },
  {
    path: "/company/leads",
    name: "Leads",
    component: Leads,
    permission: "view_requirements",
    icon: consultant,
  },
  {
    path: "/company/jobcompany",
    name: "Accounts",
    component: JobCompany,
    permission: "view_requirements",
    icon: consultant,
  },
  {
    path: "/company/outreach",
    name: "Opportunities",
    component: OutreachTablePage,
    permission: "view_requirements",
    icon: consultant,
  },
  {
    path: "/company/spoc",
    name: "",
    component: SpocOutreachSummary,
    permission: "view_requirements",
    icon: "",
  },
  {
    path: "/company/jobcompanyView",
    name: "",
    component: JobCompanyView,
    permission: "view_requirements",
    icon: "",
  },
  {
    path: "/company/setting",
    name: "Setting",
    component: Setting,
    permission: "view_setting",
    icon: setting,
  },
];
